import { nlpIntegration } from '@mi-front/api-clients';
import Fuse, { IFuseOptions } from 'fuse.js';
import { useMemo, useState } from 'react';

const FUSE_OPTIONS: IFuseOptions<nlpIntegration.TopicOutDto> = {
  threshold: 0.2,
  ignoreLocation: true,
  keys: [
    'canonical_title',
    'refined_title',
    'summary',
    'refined_summary',
    'key_points',
    'refined_key_points',
    'category',
  ],
};

/**
 * Applies a fuzzy text filter to live topics while preserving the original list order.
 */
export function useLiveTopicsTextFilter(topics: nlpIntegration.TopicOutDto[]) {
  const [textFilter, setTextFilter] = useState('');

  const fuse = useMemo(() => new Fuse(topics, FUSE_OPTIONS), [topics]);
  const normalizedFilter = textFilter.trim();

  const filteredTopics = useMemo(() => {
    if (normalizedFilter === '') {
      return topics;
    }

    const matchingTopicIds = new Set(fuse.search(normalizedFilter).map(({ item }) => item.id));
    return topics.filter((topic) => matchingTopicIds.has(topic.id));
  }, [fuse, normalizedFilter, topics]);

  return {
    textFilter,
    setTextFilter,
    filteredTopics,
  };
}
